import { Directive, ElementRef, AfterViewInit, OnDestroy } from "@angular/core";

@Directive({
  selector: "[ignite-iframe-clicker]",
})
export class IframeClickerDirective implements AfterViewInit, OnDestroy {
  private loadHandler: () => void;
  private clickHandler: () => void;

  constructor(private el: ElementRef<HTMLIFrameElement>) {}

  ngAfterViewInit(): void {
    this.loadHandler = () => {
      this.clickHandler = () => {
        this.el.nativeElement.click();
      };
      if (this.el.nativeElement.contentDocument) {
        this.el.nativeElement.contentDocument.addEventListener("click", this.clickHandler);
      }
    };
    this.el.nativeElement.addEventListener("load", this.loadHandler);
  }

  ngOnDestroy(): void {
    if (this.loadHandler) {
      this.el.nativeElement.removeEventListener("load", this.loadHandler);
    }
    if (this.el.nativeElement.contentDocument && this.clickHandler) {
      this.el.nativeElement.contentDocument.removeEventListener("click", this.clickHandler);
    }
  }
}
